// extracted by mini-css-extract-plugin
export default {"title":"Content_title","processingWrapper":"Content_processingWrapper","iwocaLogo":"Content_iwocaLogo","cta":"Content_cta Prompt_promptButton buttons_buttonLarge buttons_button"};